import { render } from "./ApprovalModal.vue?vue&type=template&id=2e56f52a&scoped=true"
import script from "./ApprovalModal.vue?vue&type=script&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&lang=js"

import "./ApprovalModal.vue?vue&type=style&index=0&id=2e56f52a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e56f52a"],['__file',"src/components/ApprovalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e56f52a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e56f52a', __exports__)) {
    api.reload('2e56f52a', __exports__)
  }
  
  module.hot.accept("./ApprovalModal.vue?vue&type=template&id=2e56f52a&scoped=true", () => {
    api.rerender('2e56f52a', render)
  })

}


export default __exports__